"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const InputAdornment_1 = __importDefault(require("@mui/material/InputAdornment"));
const react_hook_form_1 = require("react-hook-form");
const TextInput_1 = __importDefault(require("../TextInput"));
const maskPhoneNum_1 = require("./maskPhoneNum");
const PhoneTextInput = ({ control, ...rest }) => {
    return ((0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { control: control, name: "phoneNumber", render: ({ field, fieldState }) => {
            const { ref: inputRef, ...fieldProps } = field;
            return ((0, jsx_runtime_1.jsx)(TextInput_1.default
            // eslint-disable-next-line react/jsx-props-no-spreading
            , { ...fieldProps, InputLabelProps: {
                    htmlFor: "phone-number-input",
                    tooltip: "Buoy currently only supports 10-digit US cellphone numbers. Buoy will not share your phone number or communications with your employer.",
                }, InputProps: {
                    startAdornment: ((0, jsx_runtime_1.jsx)(InputAdornment_1.default, { position: "start", children: "+1" })),
                    inputProps: {
                        "data-testid": "phone-number",
                        style: {
                            paddingLeft: 0,
                        },
                    },
                }, autoComplete: "tel-national", error: fieldState.invalid, helperText: fieldState.invalid
                    ? "Please enter a 10-digit phone number."
                    : undefined, id: "phone-number-input", inputMode: "tel", inputRef: inputRef, label: "Personal cellphone number", optional: true, placeholder: "(XXX) XXX-XXXX", type: "tel", value: (0, maskPhoneNum_1.maskPhoneNum)(field.value), ...rest }));
        }, rules: {
            pattern: /^[(][0-9]{3}[)][\s][0-9]{3}[-][0-9]{4}$/,
        } }));
};
exports.default = PhoneTextInput;
//# sourceMappingURL=index.js.map